/**
 * Network Slice
 * 
 * Manages network connectivity state.
 * This replaces the NetworkContext for consistency with the store pattern.
 * 
 * The slice itself doesn't handle the event listeners - 
 * that's done in the NetworkMonitor component which updates this slice.
 */

import type { StateCreator } from 'zustand';
import type { BoundStoreState, NetworkSlice } from '../types';

// ============================================================================
// Initial State
// ============================================================================

export const networkSliceInitialState = {
  isOnline: typeof navigator !== 'undefined' ? navigator.onLine : true,
};

// ============================================================================
// Slice Creator
// ============================================================================

/**
 * Creates the network slice.
 * 
 * @param set - Zustand set function
 */
export const createNetworkSlice: StateCreator<
  BoundStoreState,
  [['zustand/devtools', never]],
  [],
  NetworkSlice
> = (set) => ({
  // State
  ...networkSliceInitialState,

  // Actions
  setIsOnline: (online: boolean) =>
    set(
      { isOnline: online },
      undefined,
      'network/setIsOnline'
    ),
});
